import { PaymentTerm, RmsContractBalance, ContractOP } from '@cemex-core/cmx-api';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  ContractActions,
  ContractActionTypes,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/contracts.actions';

export interface ContractState {
  availableContracts: {
    [productCode: string]: ContractOP[];
  };
  balanceCompleted: {
    [contractCode: string]: RmsContractBalance[];
  };
  availablePaymentTerms: PaymentTerm[];
}

export const initialState: ContractState = {
  availableContracts: {},
  balanceCompleted: {},
  availablePaymentTerms: [],
};

export function contractsReducer(state = initialState, action: ContractActions | OrderBuilderActions): ContractState {
  switch (action.type) {
    case ContractActionTypes.LOAD_AVAILABLE_CONTRACTS: {
      return {
        ...state,
        availableContracts: {
          ...state.availableContracts,
          [action.payload.productCode]: action.payload.salesDocuments,
        },
      } as ContractState;
    }
    case ContractActionTypes.BALANCE_COMPLETED: {
      return {
        ...state,
        balanceCompleted: {
          ...state.balanceCompleted,
          ...action.payload,
        },
      } as ContractState;
    }
    case ContractActionTypes.LOAD_CONTRACT_PAYMENT_TERM: {
      return {
        ...state,
        availablePaymentTerms: action.payload,
      } as ContractState;
    }
    case RESET_BUILDER:
    case ContractActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
